import { useState } from 'react';
import { API_URL } from '@constants';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/cfg-system-settings/features';

export interface Feature {
    'content_features_item_1_title': string;
    'content_features_item_1_description': string;
    'content_features_item_1_icon': string | null;
    'content_features_item_2_title': string;
    'content_features_item_2_description': string;
    'content_features_item_2_icon': string | null;
    'content_features_item_3_title': string;
    'content_features_item_3_description': string;
    'content_features_item_3_icon': string | null;
    'content_features_item_4_title': string;
    'content_features_item_4_description': string;
    'content_features_item_4_icon': string | null;
}

export interface GetFeaturesSuccessResponse {
    data: Feature;
    success: boolean;
    message: string;
}

export const useGetFeatures = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();
    const [features, setFeatures] = useState<Feature | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const request = async () => {
        setLoading(true);
        setError(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();

            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || json.message || 'Erro ao buscar features') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const result: GetFeaturesSuccessResponse = await response.json();

            setFeatures(result.data);
        } catch (err: any) {
            handleCommonErrors(err);
            setError(err.message || 'Erro ao buscar features');
        } finally {
            setLoading(false);
        }
    };

    return { features, request, loading, error };
};
